export default __webpack_public_path__ + "static/media/mw_wheel.3783e45b.mp3";